/* dio-offer.js, erzeugt von build_offerpage.py */
(function(){
  'use strict';
  /* Akkordeons */
  document.querySelectorAll('[data-acc] .dio-acc__q').forEach(function(q){
    q.addEventListener('click',function(){
      var it=q.parentNode, offen=!it.classList.contains('is-open');
      it.classList.toggle('is-open',offen);
      q.setAttribute('aria-expanded',offen?'true':'false');
    });
  });

  /* Karussells */
  document.querySelectorAll('[data-car]').forEach(function(c){
    var t=c.querySelector('[data-track]'), dots=c.querySelector('[data-dots]');
    var prev=c.querySelector('.dio-car__prev'), next=c.querySelector('.dio-car__next');
    var slides=[].slice.call(t.children);
    function step(){ return slides.length>1 ? (slides[1].offsetLeft-slides[0].offsetLeft) : t.clientWidth; }
    function maxIdx(){ var s=step(); return s>0 ? Math.max(0,Math.round((t.scrollWidth-t.clientWidth)/s)) : 0; }
    function idx(){ var s=step(); return s>0 ? Math.round(t.scrollLeft/s) : 0; }
    function go(i){ var m=maxIdx(); i=Math.max(0,Math.min(m,i)); t.scrollTo({left:i*step(),behavior:'smooth'}); }
    function upd(){
      var i=idx(), m=maxIdx();
      [].forEach.call(dots.children,function(b,k){ b.classList.toggle('on',k===i); });
      if(prev) prev.disabled=(i<=0);
      if(next) next.disabled=(i>=m);
      c.setAttribute('data-idx',i);
    }
    function build(){
      dots.innerHTML='';
      var n=maxIdx()+1;
      if(n<2 || getComputedStyle(t).overflowX==='visible'){ c.classList.add('is-static'); return; }
      c.classList.remove('is-static');
      for(var i=0;i<n;i++){
        var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label',String(i+1));
        (function(k){ b.addEventListener('click',function(){ go(k); }); })(i);
        dots.appendChild(b);
      }
      upd();
    }
    if(prev) prev.addEventListener('click',function(){ go(idx()-1); });
    if(next) next.addEventListener('click',function(){ go(idx()+1); });
    var raf=0;
    t.addEventListener('scroll',function(){ cancelAnimationFrame(raf); raf=requestAnimationFrame(upd); },{passive:true});
    var rt=0; window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(build,150); });
    build();
  });

  /* Mehr Bewertungen */
  var more=document.querySelector('[data-more]');
  if(more){ more.addEventListener('click',function(){
    document.querySelectorAll('[data-wall] .dio-hide').forEach(function(x){ x.classList.remove('dio-hide'); });
    more.hidden=true;
  }); }

  /* Countdown bis Mitternacht Europe/Berlin, startet danach neu */
  var cd=document.querySelector('[data-countdown]');
  if(cd){
    var fH=cd.querySelector('[data-cd="h"]'), fM=cd.querySelector('[data-cd="m"]'), fS=cd.querySelector('[data-cd="s"]');
    var fmt;
    try{ fmt=new Intl.DateTimeFormat('de-DE',{timeZone:'Europe/Berlin',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}); }catch(err){ fmt=null; }
    function rest(){
      var h,m,s,d=new Date();
      if(fmt){ var p={}; fmt.formatToParts(d).forEach(function(x){ p[x.type]=parseInt(x.value,10); }); h=p.hour%24; m=p.minute; s=p.second; }
      else { h=d.getHours(); m=d.getMinutes(); s=d.getSeconds(); }
      var r=86400-(h*3600+m*60+s); if(r<=0||r>86400) r=86400;
      return r;
    }
    function z(n){ return (n<10?'0':'')+n; }
    function tick(){ var r=rest(); fH.textContent=z(Math.floor(r/3600)%24); fM.textContent=z(Math.floor(r%3600/60)); fS.textContent=z(r%60); }
    tick(); setInterval(tick,1000);
  }

  /* Sticky-Leiste: weg, solange das Angebot sichtbar ist */
  var st=document.querySelector('[data-sticky]'), ang=document.getElementById('dio-angebot');
  if(st && ang && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(en){ st.classList.toggle('is-hidden',en.isIntersecting); }); },{threshold:0.05}).observe(ang);
  }

  /* Direktkauf: Menge dieser Variante im Warenkorb genau setzen, dann zur Kasse.
     Ohne JS oder bei Fehler greift das normale Formular (POST /cart/add, return_to=/checkout). */
  document.querySelectorAll('form[data-buy]').forEach(function(f){
    f.addEventListener('submit',function(ev){
      if(!window.fetch) return;
      ev.preventDefault();
      var id=f.querySelector('[name=id]').value, qty=parseInt(f.querySelector('[name=quantity]').value,10), u={};
      u[id]=qty;
      var b=f.querySelector('button'); if(b) b.disabled=true;
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:u})})
        .then(function(r){ if(!r.ok) throw new Error(r.status); window.location.href='/checkout'; })
        .catch(function(){ if(b) b.disabled=false; f.submit(); });
    });
  });
})();
